import ImagesAuthenticationSignUpSpiritoryLogoWhiteSvg from '@/public/images/authentication/sign-up/spiritory-logo-white.svg';

export { ImagesAuthenticationSignUpSpiritoryLogoWhiteSvg };
